import { render, staticRenderFns } from "./ButtonDelete.vue?vue&type=template&id=47880370&scoped=true&"
import script from "./ButtonDelete.vue?vue&type=script&lang=js&"
export * from "./ButtonDelete.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDelete.vue?vue&type=style&index=0&id=47880370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47880370",
  null
  
)

export default component.exports